
<div class="status-tag" [ngStyle]="{'background-color': this.color}">
    {{text}}
</div>

